/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button, FormControl, Grid, TextField } from '@material-ui/core';
import styles from './styles/styles';
import CreateFormErrors from './CreateFormErros';
import { useTranslation } from 'react-i18next';

type UserProfileInputs = {
  languageId: number;
};
const MenuItemsTranslationsForm = ({ CloseModal, SaveTranslations }) => {
  const menuItemTranslations = useSelector(
    (state: RootStateOrAny) => state.MenuItemsReducer.menuItemTranslations,
  );
  const classes = styles();

  const { register, handleSubmit, errors } = useForm();
  const { t } = useTranslation();

  return (
    <Grid
      container
      spacing={1}
      alignItems="center"
      className={classes.paddingBottom}
    >
      <form
        className={classes.fullWidth}
        onSubmit={handleSubmit(SaveTranslations)}
      >
        <div className={classes.scrollY}>
          <FormControl className={classes.fullWidth}>
            {menuItemTranslations.map((trans, index) => (
              <Grid item xs={12}>
                <TextField
                  inputRef={
                    index === 0 ? register({ required: true }) : register
                  }
                  ref={register}
                  defaultValue={trans?.value}
                  style={{ width: '100%', marginTop: 12 }}
                  size="small"
                  name={trans.language?.id}
                  variant="outlined"
                  label={t(trans.language?.name)}
                  error={errors.name}
                />
                <CreateFormErrors errors={errors} field={trans.language?.id} />
              </Grid>
            ))}
          </FormControl>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            variant="outlined"
            color="primary"
            onClick={CloseModal}
            className={classes.button}
          >
            {t('app.common.cancel')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            className={classes.button}
          >
            {t('app.common.save')}
          </Button>
        </div>
      </form>
    </Grid>
  );
};

export default MenuItemsTranslationsForm;
